import FilterDto from "../../../../../../dto/FilterDto"
import VilgramFileDto from "../../../../../../dto/VilagramFileDto"

export enum ActionType {
    INDEX_LOAGING = 'INDEX_LOAGING',
    INDEX_DATA = 'INDEX_DATA',
    INDEX_ERROR = 'INDEX_ERROR',
    INDEX_SET_FILTER = 'INDEX_CURRENT_PAGE',
    INDEX_RESET = 'INDEX_RESET'

}

export interface ActionIndex {
    type: ActionType.INDEX_DATA,
    data: VilgramFileDto []
}

export interface ActionNumberFilesFetchError {
    type: ActionType.INDEX_ERROR,
    message: String
}

export interface ActionSetFilter {
    type: ActionType.INDEX_SET_FILTER,
    filter: FilterDto
}


type Action = ActionIndex | ActionNumberFilesFetchError | ActionSetFilter

export default Action